import api from '../../api/_fournisseur'


const state = () => ({
    fournisseurs: [],
    fournisseur: [],
    deletedFournisseurs: [],
})

// getters
const getters = {
    fournisseurs: (state) => {
        return state.fournisseurs
    },

    fournisseur: (state) => {
        return state.fournisseur
    },

    deletedFournisseurs: (state) => {
        return state.deletedFournisseurs
    },

}

// actions
const actions = {
    /**
     * Liste des fournisseurs
     */
    getFournisseurs({commit}) {
        api.fournisseurs().then(
            response => {
                commit('SET_FOURNISSEURS', response)
            }
        )
    },

    /**
     * Enregistrer un fournisseur
     */
    saveFournisseur({commit, dispatch}, data) {
        return api.saveFournisseur(data).then(
            response => {
                if(response.status == 201) {
                    commit('SET_FOURNISSEUR', response.data)
                    dispatch('getFournisseurs')
                    return {"response": true, "id": response.data.id}
                } else {
                    return {"response": false}
                }
               
            }
        )
    },

    /**
     * Afficher un fournisseur
     */
    getFournisseur({commit}, id) {
        api.getFournisseur(id).then(
            response => {
                commit('SET_FOURNISSEUR', response)
            }
        )
    },

    /**
     * Editer un fournisseur
     */
    async editFournisseur({dispatch, commit}, {id, data}) {
        return api.editFournisseur(id, data).then(
            response => {
                dispatch('getFournisseurs')
                commit('SET_FOURNISSEUR', response)
                return true
            }
        )
    },

    /**
     * Delete un fournisseur
     */
    deleteFournisseur({dispatch}, id) {
        api.deleteFournisseur(id).then(
            response => {
                console.log(response)
                dispatch('getFournisseurs')
            }
        )
    },
    /**
     * Liste des fournisseurs
     */
    deletedFournisseur({commit}) {
        api.deletedFournisseurs().then(
            response => {
                console.log(response)
                commit('SET_DELETED_FOURNISSEUR', response)
            }
        )
    },


}

// mutations
const mutations = {
    
    SET_FOURNISSEURS(state,fournisseurs) {
        state.fournisseurs = fournisseurs
    },
    SET_FOURNISSEUR(state,fournisseur) {
        state.fournisseur = fournisseur
    },
    SET_DELETED_FOURNISSEUR(state,deletedFournisseurs) {
        state.deletedFournisseurs = deletedFournisseurs
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
